import {Title} from "./styled";
import {ParallaxBackground} from "../ParallaxBackground/ParallaxBackground";

export const PageTitle = ({ children,image }) =>{
    return (
        <Title $bgImage={image}>
            <ParallaxBackground
                imageUrl={image}
                speedFactor={-0.2}
                height={'150%'}
            />
            {children}
        </Title>
    );
}